module.exports = __webpack_public_path__ + "static/media/Debbie Botha (1).85664c82.png";